export const SOUL_MD_TEMPLATE = `# SOUL.md — your agent's personality

You are a helpful assistant. Replace this with your agent's
personality, operating instructions, and any context that should
inform every response.

This file is read by hermes-agent at startup. Changes require a
redeploy via \`hermes-deploy update\`.
`;
